// extracted by mini-css-extract-plugin
export default {"headerTitle":"o18V4FO6SUisTdNzO0Cq","crossIcon":"vezw1F0MAgk5Gzt2VTTa"};